import React from "react";
import SubmenuLayoutSix from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Six";
import * as styles from "./styles.module.css";

/**
 * See <Header> component's doc comment
 */
const SubmenuLevelThreePricing = ({ data, activeMenu }) => {
    const { id } = data ?? {};

    return (
        <div
            id={id}
            className={`submenu submenu--price max-xl:flex-col h-screen xl:h-auto ${
                activeMenu === id ? "submenu-active" : ""
            }`}
        >
            <SubmenuLayoutSix data={data} className="active" />
        </div>
    );
};
export default SubmenuLevelThreePricing;
